/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const GripDotsVerticalRegularV6 = (props) => (
  <Icon {...props} name="Grip Dots Vertical Regular V6">
    <path d="M5 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm0 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm2 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM9 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm2 5a1 1 0 1 1-2 0 1 1 0 1 1 2 0zm-2 5a1 1 0 1 1 2 0 1 1 0 1 1-2 0z" />
  </Icon>
);

export default GripDotsVerticalRegularV6;
